import ArrowDown from "../../../assets/image/revenue/arrow-down-revenue.svg";
import "./TotalMonthCard.scss";
import "../../../utils/format"
import { formatFloatNumber } from "../../../utils/format";

const TotalMonthCard = ({ title, amount, previousMonthAmount }) => {
  const percentageChange =
    previousMonthAmount !== 0
      ? ((amount - previousMonthAmount) / previousMonthAmount) * 100
      : 0;  

  const isPositiveChange = percentageChange > 0;

  return (
    <div className="frame-current-revenue-card">
      <div className="frame-date-current-revenue-card">
        <div className="frame-date-current-revenue-card">
          <p>
            {title}
          </p>
      </div>
      </div>
      <div className="frame-amount-reduce">
        <p>${amount === undefined ? 0 : formatFloatNumber(amount)} </p>
        <div
          className="frame-icon-reduceamount"
          style={{
            backgroundColor:
              isPositiveChange || amount === undefined ? "green" : "red",
            display: previousMonthAmount === undefined || previousMonthAmount === 0 ? "none" : "",
          }}
        >
          <div
            style={{
              transform:
                isPositiveChange || amount === undefined
                  ? "rotate(180deg)"
                  : "rotate(0deg)", // Rotate the arrow based on percentage change
            }}
          >
            <img src={ArrowDown} alt="arrow-down" />
          </div>
          <p
            style={{
              color: "white",
            }}
          >
            {amount === undefined
              ? 0
              : formatFloatNumber(
                  percentageChange === Infinity ? 0 : percentageChange
                )}
            %
          </p>
        </div>
      </div>
      <div className="frame-last-month-amount">
        <p>Last Period</p>
        <p>${formatFloatNumber(previousMonthAmount / 1000000)}M</p>
      </div>
    </div>
  );
};

export default TotalMonthCard;
